import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5bf18c0c&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=5bf18c0c&prod&lang=less&scoped=true&"
import style1 from "./App.vue?vue&type=style&index=1&id=5bf18c0c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf18c0c",
  null
  
)

export default component.exports